<template>
    <div class="loading-div">
        <font-awesome-icon icon="spinner" class="loading" />
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { faSpinner } from '@fortawesome/free-solid-svg-icons'

    library.add(faSpinner);

    export default {
        name: "loading",
        data() {
            return {

            }
        },
        methods: {

        },
        mounted() {

        }
    }
</script>

<style scoped>
    @import "./loading-icon.scss";
</style>


// WEBPACK FOOTER //
// src/components/LoadingIcon/LoadingIcon.vue